<template>
  <div v-if="vs">
    <slot></slot>
    <!-- <MenuBar></MenuBar> -->

    <!-- <O3DSprite>
      <PortalScene :width="10" :height="10">
        <ThankYouLayout></ThankYouLayout>
      </PortalScene>
    </O3DSprite> -->

    <O3D :py="vs.value" ref="lay">

      <FullerImage :image="require('./img/church.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/church')" :text="`Church`"></TextClicker>
          </O3D>
        </template>
      </FullerImage>

      <FullerImage :image="require('./img/game.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/game')" :text="`Boxing`"></TextClicker>
          </O3D>
        </template>
      </FullerImage>

      <!-- <FullerImage :image="require('./img/city.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/city')" :text="`City`"></TextClicker>
          </O3D>
        </template>
      </FullerImage> -->

      <FullerImage :image="require('./img/diamond-dancer.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/dance')" :text="`Dance`"></TextClicker>
          </O3D>
        </template>
      </FullerImage>

      <!-- <FullerImage :image="require('./img/code-building.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/docs')" :text="`Docs`"></TextClicker>
          </O3D>
        </template>
      </FullerImage> -->

      <FullerImage :image="require('./img/art-gallery.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/art')" :text="`Gallery`"></TextClicker>
          </O3D>
        </template>
      </FullerImage>

      <FullerImage :image="require('./img/code-building.png')">
        <template v-slot="vm">
          <O3D :px="vm.width * 0.2" :pz="1.4" :py="vm.gap - vm.height * -0.2" :sy="0.1" :sx="0.1">
            <TextClicker @clicker="goto('/building')" :text="`Code Building`"></TextClicker>
          </O3D>
        </template>
      </FullerImage>
    </O3D>
  </div>
</template>

<script>
import { RayPlay } from '../../Reusable/RayPlay'
import { makeScroller } from '../../Reusable/makeScroller'
import { O3DG2, getScreen, doLayout } from '../../Reusable/O3DG2'
// import { Vector3 } from 'three'

export default {
  mixins: [O3DG2],
  data () {
    return {
      pix: 0,
      vs: false,
      screen: false,
      layouts: {
      },
      page: {
        limitY: 0
      }
    }
  },
  methods: {
    goto (v) {
      this.$router.push(v)
    },
    setupRayPlay () {
      this.rayplay = new RayPlay({ onResize: this.onResize, onClean: this.onClean, mounter: this.ctx.touchdiv, camera: this.ctx.camera, onLoop: this.onLoop })
    },
    setupScroller () {
      this.onResize(() => {
        let page = this.page
        this.screen = getScreen({ camera: this.ctx.camera, depth: 0 })
        this.vs = makeScroller({ loop: this.onLoop, mounter: this.ctx.touchdiv, limit: { direction: 'vertical', speed: 15, canRun: true, ny: 0, get y () { return page.limitY } }, onMove: () => { this.$emit('move') } })
      })
    },
    doLayout () {
      this.screen = getScreen({ camera: this.ctx.camera, depth: 0 })
      doLayout({ group: this.$refs['lay'], layouts: this.layouts, page: this.page, screen: this.screen })
    },
    setupAutoLayout () {
      this.onResize(() => {
        this.doLayout()
      })
    }
  },
  mounted () {
    this.setupScroller()
    this.setupAutoLayout()
    this.setupRayPlay()

    this.onLoop(() => {
      let screenHeight = this.screen.height
      let innerHeight = window.innerHeight
      let px = screenHeight / innerHeight
      this.pix = px

      // this.layouts.topNavLine = {
      //   pz: 0.001,
      //   py: screenHeight * 0.5 - 56 * px + 0.5 * px
      // }
      // this.layouts.logo = {
      //   pz: 0.002,
      //   py: screenHeight * 0.5 - 56 * px
      // }
    })
  }
}
</script>

<style>
</style>